const STORAGE_KEY = "tomark-checkout-theme";

export type CheckoutTheme = "dark" | "light";

export function getStoredTheme(): CheckoutTheme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* ignore */
  }
  return "dark";
}

export function applyTheme(theme: CheckoutTheme) {
  document.documentElement.setAttribute("data-theme", theme);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* ignore */
  }
}

export function toggleTheme(current: CheckoutTheme): CheckoutTheme {
  const next = current === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
}
